import { createFileRoute, notFound } from "@tanstack/react-router";
import { pageBySlugQueryOptions } from "src/react-query/react-query";
import { Timeline } from "src/components/content/timeline";
import CkEditorContent from "src/components/content/ck-editor-content";
import { seo } from "src/utils/seo";

export const Route = createFileRoute("/_breadcrumbs/$pageSlug")({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const page = await context.queryClient.ensureQueryData(
      pageBySlugQueryOptions(params.pageSlug),
    );

    if (!page) {
      throw notFound();
    }

    return {
      page,
      crumb: page.title,
    };
  },
  head: ({ loaderData }) => {
    return {
      meta: [
        ...seo({
          title: `${loaderData?.page.title} | VESAS`,
        }),
      ],
    };
  },
});

function RouteComponent() {
  const { page } = Route.useLoaderData();

  if (!page) {
    return notFound();
  }

  return (
    <div className={"container mx-auto max-w-[1200px]"}>
      <h1 className={"my-8 text-center text-5xl font-extrabold"}>
        {page.title}
      </h1>
      <div className={"flex flex-col gap-10"}>
        {page.dynamic_content?.map((item, index) => {
          switch (item.__component) {
            case "shared.timeline":
              return (
                <Timeline
                  className={"w-full md:px-10"}
                  timeline={item}
                  key={index}
                />
              );
            case "shared.content":
              if (!item.ckeditor_content) return null;
              return (
                <CkEditorContent
                  className={"w-full md:px-10"}
                  htmlContent={item.ckeditor_content}
                  key={index}
                ></CkEditorContent>
              );
          }
        })}
      </div>
    </div>
  );
}
